import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { routesV3 } from 'src/app/layout-v3/shared/const/routes-config';
import { AuthService } from '../services';
import { AdminV3Service } from 'src/app/layout-v3/shared/services/admin-v3.service';

 // Ajusta la ruta según tu proyecto

@Injectable({
  providedIn: 'root'
})
export class ErrorPageGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private adminV3Service: AdminV3Service
  ) {}

   canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if(!this.authService.isLoggedIn){
            const loginRoute = this.authService.getRedirectLoginRoute();
           return this.router.navigate([loginRoute]); 
        } else {
            const flag = sessionStorage.getItem('resourceForbidden');
            if(flag === 'true'){ 
               this.adminV3Service.setDistrictId('');
               this.adminV3Service.resetCurrentAdmin();    
               return true;
            } else {
              return this.router.navigate([routesV3.cloudapps.route]);
            }
         
        }    
   }
}